import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

const auth = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

export const getLogisticsByTaskId = async (timelineTaskId) => {
  const res = await axios.get(
    `${API_URL}/api/logistics/${timelineTaskId}`,
    auth()
  );
  return res.data;
};

export const addLogisticsEntry = async (entry) => {
  const res = await axios.post(`${API_URL}/api/logistics`, entry, auth());
  return res.data;
};

export const updateLogisticsEntry = async (id, entry) => {
  const res = await axios.put(`${API_URL}/api/logistics/${id}`, entry, auth());
  return res.data;
};

export const deleteLogisticsEntry = async (id) => {
  const res = await axios.delete(`${API_URL}/api/logistics/${id}`, auth());
  return res.data;
};

export const getLogisticsByProductId = async (productId, options = {}) => {
  const idPresupuesto = options.idPresupuesto;
  const idPresupuestoA3Pedido = options.idPresupuestoA3Pedido;
  const params = {};
  if (
    idPresupuesto != null &&
    idPresupuesto !== "" &&
    Number.isFinite(Number(idPresupuesto))
  ) {
    params.idPresupuesto = Number(idPresupuesto);
  }
  if (
    idPresupuestoA3Pedido != null &&
    idPresupuestoA3Pedido !== "" &&
    Number.isFinite(Number(idPresupuestoA3Pedido))
  ) {
    params.idPresupuestoA3Pedido = Number(idPresupuestoA3Pedido);
  }
  const response = await axios.get(
    `${API_URL}/api/productionTimeline/logistics/${productId}`,
    { ...auth(), params },
  );
  return response.data;
};
